import type { ContentBlock } from '@/hooks/use-abuse'

interface ContentBlocksFeedProps {
  blocks: ContentBlock[]
  isLoading: boolean
}

export function ContentBlocksFeed({
  blocks,
  isLoading,
}: ContentBlocksFeedProps): React.JSX.Element {
  if (isLoading && blocks.length === 0) {
    return (
      <div className="flex h-32 items-center justify-center">
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-admin-500 border-t-transparent" />
      </div>
    )
  }

  if (blocks.length === 0) {
    return <p className="py-8 text-center text-sm text-text-tertiary">No recent content blocks</p>
  }

  return (
    <div className="max-h-[400px] space-y-3 overflow-y-auto">
      {blocks.map((block) => (
        <div key={block.email_id} className="rounded-lg border border-surface-3 px-3 py-2.5">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-text-primary">{block.account_id}</span>
            <span className="text-xs text-text-tertiary">
              {new Date(block.timestamp).toLocaleString()}
            </span>
          </div>
          <p className="mt-1 text-xs text-text-secondary">{block.reason}</p>
        </div>
      ))}
    </div>
  )
}
